module.exports = __webpack_public_path__ + "img/41-l.4ca88320.png";